import { render, staticRenderFns } from "./EditEventRoles.vue?vue&type=template&id=eca231cc&scoped=true"
import script from "./EditEventRoles.vue?vue&type=script&lang=ts"
export * from "./EditEventRoles.vue?vue&type=script&lang=ts"
import style0 from "./EditEventRoles.vue?vue&type=style&index=0&id=eca231cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca231cc",
  null
  
)

export default component.exports